import React from "react";
import { url } from "../../utils/const";

function SorteoLive() {
  const isLocalDevelopment =
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") &&
    window.location.port === "3000";
  const simulatorHost = isLocalDevelopment
    ? window.location.protocol + "//" + window.location.hostname + ":4500"
    : url;

  return (
    <main style={{ width: "100vw", height: "100vh", overflow: "hidden", background: "#000" }}>
      <iframe
        src={simulatorHost + "/sorteo"}
        title="Simulador de sorteo La Reina"
        allow="autoplay; fullscreen"
        allowFullScreen
        style={{ width: "100%", height: "100%", border: 0, display: "block" }}
      />
    </main>
  );
}

export default SorteoLive;
